module.exports = __webpack_public_path__ + "static/media/assa-heart-percent.42a69bb2.svg";